import React from "react";
import { GridToolbarQuickFilter } from "@mui/x-data-grid";
import SearchIcon from "@mui/icons-material/Search";
import { InputAdornment } from "@mui/material";
import { useTranslation } from "react-i18next";

const CustomGridToolbarQuickFilterNew = (props) => {
  const { t, i18n } = useTranslation();
  const isVI = i18n.language === "vi";

  return (
    <GridToolbarQuickFilter
      {...props}
      placeholder={t("common.search")}
      variant="outlined"
      size="small"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon fontSize="small" sx={{ color: "#D0D5DD" }} />
          </InputAdornment>
        ),
      }}
      sx={{
        "& .MuiInputBase-root": {
          borderRadius: "8px",    
          backgroundColor: "#FEFEFE",
          minHeight: "40px",
          minWidth: isVI ? "555px" : "593px",
        },
        // viền
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: "#D0D5DD",           
        },
        "&:hover .MuiOutlinedInput-notchedOutline": {
          borderColor: "#D0D5DD",           
        },
        "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
          borderColor: "#D0D5DD",           
        },
        "& .MuiInputBase-input::placeholder": {
          color: "#000000",                 
        },
      }}
    />
  );
};

export default CustomGridToolbarQuickFilterNew;
